import { render, staticRenderFns } from "./WysiwygField.vue?vue&type=template&id=1a7b6616&scoped=true&"
import script from "./WysiwygField.vue?vue&type=script&lang=js&"
export * from "./WysiwygField.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygField.vue?vue&type=style&index=0&id=1a7b6616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b6616",
  null
  
)

export default component.exports